module.exports = __webpack_public_path__ + "img/william.8bc9df2.png";